module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "requestData": _vm.buildRequestData(),
      "storage-key": "info-projects-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "btn-group flex-wrap",
          attrs: {
            "id": "project-buttons",
            "data-toggle": "buttons",
            "role": "group"
          }
        }, [(_vm.canEdit(row.data)) ? _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": _vm.route('info-projects.edit', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.edit')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit(row.data)) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.deleteProject(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.delete')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit(row.data)) ? _c('button', {
          staticClass: "btn btn-success btn-sm publish",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.publishProject(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        }), _vm._v(" " + _vm._s(_vm.trans('projects.publish')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.canEdit(row.data) || _vm.disableActions) ? _c('span', [_vm._v("Diese Info ist in dieser Ansicht nicht bearbeitbar")]) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af2b3492"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/InfoProjects.vue
// module id = 131
// module chunks = 0